<div class="empty-state-container">
    @let config = emptyConfig();
    @if (config && config.icon) {
      <mat-icon class="empty-state-icon" [svgIcon]="config.icon" />
    }
    @if (config && config.emptyTitle) {
      <h2>{{ config.emptyTitle | translate }}</h2>
    }
    @if (config && config.emptySubTitle) {
      <p>{{ config.emptySubTitle | translate }}</p>
    }

    @if (showButton() && config && config.emptyButton) {
      <app-general-button
        [buttonStyle]="'primary'"
        [buttonHeight]="32"
        [buttonName]="config?.emptyButton || ''"
        [iconStart]="config && !config.emptyButtonIconLeft ? config.emptyButtonIcon : ''"
        [iconEnd]="config && config.emptyButtonIconLeft ? config.emptyButtonIcon : ''"
        (buttonClicked)="buttonClickedEvent.emit()"
      />
    }
  </div>
